import React from 'react';
import { Loader2 } from 'lucide-react';
import { AdminSignIn } from '../../components/admin/AdminSignIn';
import { AdminWorkspace } from '../../components/admin/AdminWorkspace';
import { useAdminSession } from '../../hooks/useAdminSession';
export function AdminPage() {
  const session = useAdminSession();
  if (session.status === 'checking') {
    return <main className="flex min-h-screen w-full items-center justify-center bg-cream" aria-busy="true" data-id="element-699" data-mp="1yxjwshvlitol">
        <div className="flex items-center gap-3 text-sm text-clay" data-id="element-700" data-mp="1671pf4nua65d">
          <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-701" data-mp="168w5o5o61a34" />
          Checking your sign-in…
        </div>
      </main>;
  }
  if (session.status === 'signedOut') {
    return <AdminSignIn linkError={session.linkError} data-id="element-702" data-mp="1g3o6rjgyif2n" />;
  }
  return <AdminWorkspace email={session.email} onSignOut={session.signOut} data-id="element-703" data-mp="2vkyd8f192qmm" />;
}